import { ApolloCache, gql } from '@apollo/client';

export const writeUnreadOffersQuery = (cache: ApolloCache<object>, count: number) => {
  cache.writeQuery({
    data: {
      getUnreadConnectionOfUserByConnectionType: {
        __typename: 'ListMetaData',
        count,
      },
    },
    query: gql`
      query unreadOffers {
        getUnreadConnectionOfUserByConnectionType(connectionType: "invitation") {
          count
        }
      }
    `,
  });
};

export const writeUnreadApplicationsQuery = (cache: ApolloCache<object>, count: number) => {
  cache.writeQuery({
    data: {
      getUnreadConnectionOfUserByConnectionType: {
        __typename: 'ListMetaData',
        count,
      },
    },
    query: gql`
      query unreadApplications {
        getUnreadConnectionOfUserByConnectionType(connectionType: "application") {
          count
        }
      }
    `,
  });
};

export const writeUnreadMessagesQuery = (cache: ApolloCache<object>, count: number) => {
  cache.writeQuery({
    data: {
      getUnreadCountMessagesForCandidate: {
        __typename: 'ListMetaData',
        count,
      },
    },
    query: gql`
      query unreadMessages {
        getUnreadCountMessagesForCandidate {
          count
        }
      }
    `,
  });
};
